<script>
import ListExploreLiveClassComponent from '../../features/lists/ListExploreLiveClassComponent';
import ModalStreamLiveClassView from '../modals/ModalStreamLiveClassView';
import ModalStudentInfoView from '../../../account/views/ModalStudentInfoView';

export default {
  name: 'ListExploreLiveClassView',
  components: {
    'modal-stream-live-class': ModalStreamLiveClassView,
    'modal-student-info-view': ModalStudentInfoView,
  },
  extends: ListExploreLiveClassComponent,
};
</script>

<template>
  <div class="list-body">
    <!-- Barra de búsqueda y contador integrada -->
    <div class="stream_toolbar">
      <div class="stream_search_box">
        <el-input
          v-model="searchName"
          placeholder="Buscar clase en vivo por título o tema..."
          prefix-icon="Search"
          clearable
          class="stream_search_input"
          @input="onSearchInput"
          @clear="onClearSearch"
          @keyup.enter="onSearchSubmit"
        />
      </div>
      <div class="stream_toolbar_meta">
        <span
          v-if="filteredCollection && filteredCollection.length > 0"
          class="stream_count_badge"
        >
          <i class="fas fa-signal" />
          Mostrando <strong>{{ filteredCollection.length }}</strong> clase(s) en vivo
        </span>
      </div>
    </div>

    <!-- Grilla de clases en vivo -->
    <div
      v-loading="isListLoading"
      element-loading-text="Cargando clases en vivo..."
      class="row"
    >
      <div
        v-for="item in filteredCollection"
        :key="item.id"
        class="col-xl-3 col-lg-4 col-md-6 col-12 d-flex"
      >
        <div class="stream_1 mb-30">
          <router-link :to="'/estudiante/en-vivo/' + item.id + '/detalles'">
            <div class="stream_thumb">
              <img
                v-if="getYoutubeThumbnail(item.streamUrl)"
                :src="getYoutubeThumbnail(item.streamUrl)"
                :alt="item.title"
                class="stream_thumb_img"
                loading="lazy"
              >
              <div
                v-else
                class="stream_thumb_fallback"
              >
                <i class="fas fa-broadcast-tower" />
              </div>

              <div class="stream_thumb_topbar">
                <span class="stream_live_badge">
                  <span class="live_pulse_dot" /> EN VIVO
                </span>
              </div>

              <div class="stream_play_btn">
                <i class="fas fa-play" />
              </div>
            </div>

            <div class="stream_bg">
              <div class="stream_meta_row">
                <span class="stream_course">
                  <i class="fas fa-graduation-cap" />
                  {{ item.course || 'Clase General' }}
                </span>
              </div>

              <h4
                class="stream_title"
                :title="item.title"
              >
                {{ item.title }}
              </h4>

              <div class="stream_author">
                <img
                  :src="mapProfileImageUrl(item)"
                  :alt="item.publisherTitle"
                  class="stream_author_img"
                  @error="onAvatarError"
                >
                <div class="stream_author_info">
                  <span class="stream_author_name">{{ item.publisherTitle || 'Profesor' }}</span>
                  <span class="stream_author_role">Instructor en vivo</span>
                </div>
              </div>

              <div class="stream_action">
                <span class="stream_status_indicator is_live">
                  <span class="status_dot" /> En transmisión
                </span>
                <span class="btn_stream_action stream_cta_live">
                  Entrar a la Clase <i class="fas fa-arrow-right" />
                </span>
              </div>
            </div>
          </router-link>
        </div>
      </div>

      <!-- Estado vacío -->
      <div
        v-if="isCollectionEmpty(filteredCollection)"
        class="col-12"
      >
        <div class="stream_empty_state">
          <div class="stream_empty_icon">
            <i class="fas fa-broadcast-tower" />
          </div>
          <h4>No se encontraron clases en vivo</h4>
          <p>{{ searchName ? 'No hay resultados que coincidan con tu búsqueda.' : 'No hay transmisiones activas en este momento.' }}</p>
          <el-button
            v-if="searchName"
            type="primary"
            size="small"
            class="btn-primary mt-3"
            @click="onClearSearch"
          >
            Limpiar búsqueda
          </el-button>
        </div>
      </div>

      <!-- Paginación -->
      <div
        v-if="pagination.totalPages > 1"
        class="col-12 d-flex justify-content-center mt-3"
      >
        <el-pagination
          v-model:current-page="currentPage"
          background
          layout="prev, pager, next"
          :page-count="pagination.totalPages"
          @current-change="onPageChange"
        />
      </div>
    </div>

    <!-- Modales de soporte -->
    <modal-stream-live-class
      v-if="modalItemLiveClass.isVisible"
      :conf="modalItemLiveClass"
      :form-data="itemLiveClass"
    />
    <modal-student-info-view
      v-if="modalSubscriptionInfo.isVisible"
      :form-data="studentInfoItem"
      :conf="modalSubscriptionInfo"
    />
  </div>
</template>
